<template lang="pug">
span.cart-link__count(v-if="cartCountText" v-text="cartCountText")
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: 'CartLineCount',
    computed: {
      ...mapState({
        cartData: (state) => state.cart.checkout,
      }),
      cartCountText() {
        return this.cartData.item_count < 1 ? null : this.cartData.item_count;
      },
    },
  };
</script>
